import { on, select, selectAll } from 'modules/dom'
import { map } from 'modules/utils'

const WEBINAR_LOGIN_REQUIRED_SELECTOR = '.js-webinar-login-required'
const VIEW_MORE_SELECTOR= '.js-view-more'
const MODAL_LOGIN_SELECTOR = '.modal-login'
const MODAL_LOGIN_WRAPPER_SELECTOR = '.modal-login__wrapper'

export default function (el) {
  const viewMoreButtonEl = select(VIEW_MORE_SELECTOR, el)

  viewMoreButtonEl.addEventListener('click', function (e) {
    e.preventDefault()

    const href = this.getAttribute('href')

    // Remove scrollPosition in the session storage
    sessionStorage.removeItem('scrollPosition')

    // Redirect to the href
    window.location.href = href

    window.addEventListener('unload', () => {
      sessionStorage.removeItem('scrollPosition')
    })
  })

  // Tab index when click button register now show popup login
  const webinarRegisterButtons = selectAll(WEBINAR_LOGIN_REQUIRED_SELECTOR, el)
  const modalLogin = select(MODAL_LOGIN_SELECTOR, document)
  const modalWrapperLogin = select(MODAL_LOGIN_WRAPPER_SELECTOR, document)
  if (webinarRegisterButtons.length > 0 && modalLogin) {
    map((button) => {
      if (button) {
        on('keyup', function (e) {
          if (e.keyCode == 13 || e.which == 13) {
            modalWrapperLogin.focus()
          }
        }, button)
      }
    }, webinarRegisterButtons)
  }
}
